import React, { useEffect, useState } from "react";
import Select from "react-select";

const Selection = (props) => {
  const [value, setValue] = useState(null);
  const [options, setOptions] = useState(props.options);
  const [subject, setSubject] = useState("");

  const handleChange = (val) => {
    setSubject(val.data.subject);
    setValue(val);
    let temp = {
      id: val.id,
      children: val.value,
      index: val.value.length === 0 ? val.index : val.index + 1,
    };
    props.setValue(temp, val);
  };

  return (
    <>
      {/*<b>{options[0].subject}</b>*/}
      <Select
        value={value}
        onChange={(val) => handleChange(val)}
        options={options.map((item) => ({
          value: item.children,
          label: item.name,
          id: item.id,
          index: props.number,
          data: item,
        }))}
        placeholder={props.placeholder}
      />
    </>
  );
};

export default Selection;
